import { Loader2, Send } from "lucide-react";
import { Button } from "../../ui/button";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../../ui/dialog";

/**
 * Dialog for marking a billing as "Sent" by logging date & time.
 * After submission, the billing's payment_status flips from "pending" to "sent"
 * which causes the table row to replace the Send icon with the $ Record Payment
 * icon for that billing.
 */
const MarkSentDialog = ({
  open,
  onOpenChange,
  selectedBilling,
  form,
  onFormChange,
  onSubmit,
  isSubmitting,
  title,
}) => {
  const handleFieldChange = (field, value) => {
    onFormChange({ ...form, [field]: value });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {title || `Mark as Sent – App #${selectedBilling?.billing_number}`}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="form-group">
            <Label htmlFor="mark-sent-date">Date Sent *</Label>
            <Input
              id="mark-sent-date"
              type="date"
              value={form.date}
              onChange={(e) => handleFieldChange("date", e.target.value)}
              data-testid="mark-sent-date-input"
            />
          </div>

          <div className="form-group">
            <Label htmlFor="mark-sent-time">Time Sent</Label>
            <Input
              id="mark-sent-time"
              type="time"
              value={form.time}
              onChange={(e) => handleFieldChange("time", e.target.value)}
              data-testid="mark-sent-time-input"
            />
          </div>

          <div className="flex justify-end gap-2 pt-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              disabled={isSubmitting || !form.date}
              data-testid="submit-mark-sent-btn"
            >
              {isSubmitting ? (
                <Loader2 className="w-4 h-4 animate-spin mr-2" />
              ) : (
                <Send className="w-4 h-4 mr-2" />
              )}
              Mark as Sent
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MarkSentDialog;
